<template>
  <div class="pagination">
    <el-pagination
      class="table-pagination"
      background
      layout="prev, pager, next, jumper, slot, total"
      :total="pageInfo.total"
      :current-page.sync="pageInfo.currentPage"
      :page-size="pageInfo.pageSize"
      @current-change="$emit('pageChange', $event)"
    >
      <span class="page-size">{{ pageInfo.pageSize }}条/页</span>
    </el-pagination>
    <el-dropdown
      v-if="cellSizeVisible"
      placement="top"
      :show-timeout="50"
      @command="$emit('cellSizeChange', $event)"
    >
      <div class="change-size">
        <i class="el-icon-s-grid"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="small">紧凑</el-dropdown-item>
        <el-dropdown-item command="normal">舒适</el-dropdown-item>
        <el-dropdown-item command="large">宽敞</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "pagination",
  props: {
    pageInfo: Object,
    cellSizeVisible: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  align-items: center;
  .table-pagination .el-pagination__total {
    margin-left: 20px;
  }
  .page-size {
    font-size: 13px;
    color: #606266;
    margin-left: 10px;
    margin-right: 4px;
    font-weight: normal;
  }
  .change-size {
    font-size: 20px;
    display: block;
    min-width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border: 1px solid #dee1e6;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    cursor: pointer;
    &:hover {
      border-color: #407fff;
      background-color: #f3f3f5;
      box-shadow: 0 0 10px rgba(64, 127, 255, 0.5);
    }
  }
}
</style>
